/**
 * Default timing values for assessments
 */
export const ASSESSMENT_TIMING_DEFAULTS = {
  /**
   * Default time per question in seconds (30 seconds)
   */
  DEFAULT_SECONDS_PER_QUESTION: 30
};




